import type { SVGProps } from "react";

export function IconDarkBlueBag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="6"
        y="6"
        width="36"
        height="36"
        fill="#63B2FF"
        stroke="#63B2FF"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M36 25L28.8995 32.1005C27.043 33.957 24.525 35 21.8995 35V35C16.4322 35 12 30.5678 12 25.1005V25M36 25H28M36 25V33"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M20.5 6V13H27.5V6"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
